"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandContext = void 0;
var _react = require("react");
var BrandContext = /*#__PURE__*/(0, _react.createContext)('app');
exports.BrandContext = BrandContext;